class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  connectedCallback() {
    // this.setupDetailsElements();
    this.setupMegaMenuLinks();
  }

  setupDetailsElements() {
    const detailsElements = this.querySelectorAll('header-menu > details');
    
    detailsElements.forEach(detail => {
      detail.addEventListener('mouseenter', () => {
        detail.setAttribute('open', '');
        detail.querySelector('summary').setAttribute('aria-expanded', 'true');
      });

      detail.addEventListener('mouseleave', () => {
        detail.removeAttribute('open');
        detail.querySelector('summary').setAttribute('aria-expanded', 'false');
      });
    });
  }

  setupMegaMenuLinks() {
    const links = this.querySelectorAll('.mega-menu__link--level-2[data-index]');
    if (links.length === 0) return;
    const parent = links.length > 0 ? links[0].closest('.custom-mega-menu') : null;
    if (!parent) return;
    
    links.forEach(link => {
      link.addEventListener('mouseenter', () => {
        const index = link.getAttribute('data-index');
        
        const submenus = parent.querySelectorAll('.custom-mega-menu__submenu');
        submenus.forEach(submenu => submenu.classList.remove('active'));
        
        const targetSubmenu = parent.querySelector(`.custom-mega-menu__submenu[data-index="${index}"]`);
        if (targetSubmenu) {
          targetSubmenu.classList.add('active');
        }
      });
    });
  }

  closeNestedDetails() {
    this.querySelectorAll('details[open]').forEach((detail) => {
      if (detail === this.mainDetailsToggle) return;
      detail.removeAttribute('open');
      detail.querySelector('summary')?.setAttribute('aria-expanded', 'false');
    });
  }

  close() {
    super.close();
    this.closeNestedDetails();
  }

  onToggle() {
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.closeNestedDetails();

      document.querySelectorAll('header-menu').forEach((menu) => {
        if (menu !== this) menu.close?.();
      });

      document.querySelectorAll('details-modal').forEach((modal) => {
        if (modal.isOpen?.()) modal.close(false);
      });
    } else {
      this.closeNestedDetails();
    }

    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
